/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function CloseCircle(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2zm4.655 5.333a.9.9 0 0 0-1.272.001l-3.1 3.105-.064.052a.4.4 0 0 1-.503-.052L8.617 7.334a.9.9 0 0 0-1.273-.001l-.08.092a.9.9 0 0 0 .079 1.181l3.103 3.108a.4.4 0 0 1 0 .566l-3.103 3.109a.9.9 0 0 0 1.274 1.271l3.099-3.106a.4.4 0 0 1 .566 0l3.1 3.106a.9.9 0 0 0 1.273.001l.081-.092a.9.9 0 0 0-.08-1.18l-3.103-3.11a.4.4 0 0 1 0-.565l3.103-3.108a.9.9 0 0 0 0-1.273z"
  }));
}